import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const items = [
  {
    title: 'Narrativa con corazón',
    feedback:
      'Traducimos la propuesta técnica en una experiencia sensible que pone a los animalitos en el centro sin perder orden ni credibilidad.',
  },
  {
    title: 'Producción profesional',
    feedback:
      'TNO Network aporta metodología, despliegue y calidad audiovisual para que el evento se vea tan bien como se siente.',
  },
  {
    title: 'Valor real para las marcas',
    feedback:
      'La Expo gana un argumento comercial más fuerte: patrocinadores visibles, integrados a la historia y respaldados más allá del evento.',
  },
];

const PorQueTNO = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography variant="h4" fontWeight={700} align="left" gutterBottom>
          ¿Por qué TNO Network
          <br />
          para Expo Mascotas Caracas?
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              width="100%"
              height="100%"
              data-aos="fade-up"
              component={Card}
              display="flex"
              flexDirection="column"
              sx={{ borderTop: 4, borderColor: theme.palette.primary.main }}
            >
              <CardContent sx={{ flex: 1 }}>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.title}
                </Typography>
                <Typography color="textSecondary">{item.feedback}</Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PorQueTNO;
